module.exports = __webpack_public_path__ + "static/img/dark-task.9d0b52ac.png";